module.exports = __webpack_public_path__ + "img/icon-iron.18e54b38.svg";